class confettiAnimation {
  show(canvas) {
    var context = canvas.getContext("2d");
    var width = canvas.width = window.innerWidth;
    var height = canvas.height = window.innerHeight + 15;
    var particle = [];
    var particleCount = 0,
      gravity = 0.3,
      colors = [
        '#009bde', '#46c70e', '#f88e04', '#FFF176', '#9C27B0', '#EC407A', '#ffffff'
      ];


    for (var i = 0; i < 300; i++) {

      particle.push({
        x: width / 2,
        y: height / 2.2,
        boxW: randomRange(5, 20),
        boxH: randomRange(5, 20),
        size: randomRange(2, 8),

        spikeran: randomRange(3, 5),

        velX: randomRange(-8, 8),
        velY: randomRange(-50, -10),

        angle: convertToRadians(randomRange(0, 360)),
        color: colors[Math.floor(Math.random() * colors.length)],
        anglespin: randomRange(-0.2, 0.2),

        draw: function () {


          context.save();
          context.translate(this.x, this.y);
          context.rotate(this.angle);
          context.fillStyle = this.color;
          context.beginPath();
          context.fillRect(this.boxW / 2 * -1, this.boxH / 2 * -1, this.boxW, this.boxH);
          context.fill();
          context.closePath();
          context.restore();
          this.angle += this.anglespin;
          this.velY *= 0.999;
          this.velY += 0.3;

          this.x += this.velX;
          this.y += this.velY;
          if (this.y < 0) {
            this.velY *= -0.2;
            this.velX *= 0.9;
          }
          if (this.y > height) {
            this.anglespin = 0;
            this.y = height;
            this.velY *= -0.2;
            this.velX *= 0.9;
          }
          if (this.x > width || this.x < 0) {

            this.velX *= -0.5;
          }
        }
      });
    }
    var r1 = {
      x: width / 2 - 150,
      y: height / 2 - 150,
      width: 300,
      height: 300,
      velX: 0,
      velY: -10,
      img: loadImage(""),
      alphatop: 100
    };

    function drawScreen() {
      var size = 20;
      var pFontName = "Lucida Sans Unicode";
      context.font = size + "px " + pFontName;
      context.fillText("", width / 2, 600);
      if (r1.alphatop < 1) {
        r1.alphatop += 0.01;
      } else {
        r1.alphatop = 1;
      }
      context.globalAlpha = r1.alphatop;
      context.drawImage(r1.img, r1.x, r1.y);
      context.textAlign = 'center';


      if (r1.alphatop === 1) {
        r1.velY *= .999;
        r1.velY += 0.3;

        r1.x += r1.velX;
        r1.y += r1.velY;
      }

      if (r1.y + r1.height > height) {
        r1.anglespin = 0;
        r1.y = height - r1.height;
        r1.velY *= -0.5;
        r1.velX *= 0.9;
      }


      context.globalAlpha = 1;
      for (var i = 0; i < particle.length; i++) {
        particle[i].draw();

      }


    }

    function loadImage(url) {
      var img = document.createElement("img");
      img.src = url;
      return img;
    }

    function update() {


      context.clearRect(0, 0, width, height);

      drawScreen();
      requestAnimationFrame(update);
    }

    update();


    function randomRange(min, max) {
      return min + Math.random() * (max - min );
    }

    function convertToRadians(degree) {
      return degree * (Math.PI / 180);
    }
  }
}

const confetti = new confettiAnimation();
export { confetti };



// WEBPACK FOOTER //
// ./src/framework/utils/confetti-animation.js